<template>
  <div>
    <Header v-if="isLoggedIn" />
    <header v-else class="header header--error">
      <div class="header--bg">
        <ul class="header__top">
          <li class="lang lang--show">
            <span class="en" @click="changeLocaleClick('en')"><img
                :class="{ 'active': lang == 'en' }"
                :src="`${$imgUrl}/lang/en.svg`" alt="English"></span>
            <span class="ja" @click="changeLocaleClick('ja')"><img
                :class="{ 'active': lang == 'ja' }"
                :src="`${$imgUrl}/lang/ja.svg`" alt="日本語"></span>
          </li>
        </ul>
      </div>
      <div class="max_width">
        <router-link to="/">
          <picture>
            <source media="(min-width: 769px)"
              :srcset="`${$imgUrl}/header/logo.svg`">
            <img class="logo" :src="`${$imgUrl}/header/logo-sp.png`"
              :alt="$t('sitetitle')">
          </picture>
        </router-link>
        <a class="contact" :href="$contactUrl" target="_blank" rel="noopener">
          <span>{{ $t("contact") }}</span></a>
      </div>
    </header>
  </div>
</template>

<script>
import Header from '@/views/AppHeader'
export default {
  name: 'ErrorHeader',
  components: {
    Header
  },
  data() {
    return {
      isLoggedIn: false
    }
  },
  created() {
    try {
      this.isLoggedIn = window.localStorage.getItem('logIn') === 'true';
    } catch (error) {
      console.warn('Failed to access localStorage:', error);
      this.isLoggedIn = false;
    }
  },
  computed: {
    lang() {
      return this.$store.state.locales.locale;
    }
  },
  methods: {
    changeLocaleClick(v) {
      this.$store.dispatch("locales/getLocaleActions", v);
    }
  }
}
</script>
<style scoped lang="scss">
.header--error {
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row-reverse;
    background-color: #286a7a;

    .header--bg {
      background-color: transparent;
      box-shadow: none;
      border: none;
    }

    .header__top {
      width: auto;
    }
  }

  .contact {
    line-height: 1;
  }

  .header__top,
  .cover {
    justify-content: flex-start;
  }

  .lang,
  .logo {
    position: static;
  }

  .max_width {
    padding: 1em;
    align-items: center;
  }

  @media (max-width: 768px) {
    .contact {
      color: #fff;
    }

    .lang {
      display: flex;
      background-color: transparent;

      span {
        img {
          width: 4rem;
        }

        &.en,
        &.ja {
          &::after {
            content: "";
          }
        }
      }
    }
  }
}
</style>
